var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{style:(_vm.style),attrs:{"stack":"","flat":"","no-caps":"","icon":_vm.icon,"to":_vm.to,"label":_vm.label,"size":"14px","color":"black"},on:{"click":_vm._onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }